import AppModal from '../../common/AppModal';
import { Flex, LoadingSpin } from '../../common';
import SelfRateItem from './SelfRateItem';

export interface SelfRatingModalProps {
  open: boolean;
  hide: () => void;
  items: ReserveVotableEntity[];
  reasons: VoteRatingReasonEntity[];
  submit: (id: number, payload: CreateReserveVoteEntity) => Promise<any>;
  loading?: boolean;
  type?: ComponentVariant;
}

export function SelfRatingModal ({
  hide,
  open = false,
  loading = false,
  items = [],
  reasons,
  submit
}: SelfRatingModalProps) {

  return (
    <AppModal
      width="90%"
      variant="nurture"
      footer={null}
      onCancel={hide}
      open={items.length === 0 ? false : open}
      destroyOnClose
      title="به غذاها امتیاز دهید"
      style={{ maxWidth: '850px' }}
    >
      {loading ?
        <LoadingSpin className="text-white" /> :
        <Flex direction="column">
          <p className="text-app-gray-darker">لطفا به غذاهایی که تازه دریافت کردید امتیاز دهید</p>
          <Flex direction="column">
            {items.map((item, index) => (
              <SelfRateItem
                key={index}
                item={item}
                reasons={reasons}
                submit={submit}
              />
            ))}
          </Flex>
        </Flex>
      }
    </AppModal>
  );
};

export default SelfRatingModal;
